import { TomSvg, TrixSvg } from "assets/svg";
import OraculoSvg from "assets/svg/OraculoSvg";
import {
  NAV_ITEM_TYPE_COLLAPSE,
  NAV_ITEM_TYPE_ITEM,
} from "constants/navigation.constant";
import { HiOutlineInformationCircle, HiOutlineViewBoards } from "react-icons/hi";

const navigationConfig = [
  {
    key: "home",
    path: "/home",
    title: "Painel Operacional",
    translateKey: "nav.home",
    icon: "home",
    type: NAV_ITEM_TYPE_ITEM,
    authority: [],
    subMenu: [],
  },
  {
    key: "financeDashboard",
    path: "/finance-dashboard",
    title: "Painel Financeiro",
    translateKey: "nav.financeDashboard",
    icon: "HiOutlineCash",
    type: NAV_ITEM_TYPE_ITEM,
    authority: [
      "email:cliente.cometrix",
      "email:marques",
      "email:qatrix@teste.com.br",
      "email:cmx.qa@cometrix.com.br"
    ],
    subMenu: [],
  },
  {
    key: "controlTower",
    path: "",
    title: "Torre de Controle",
    translateKey: "nav.controlTower",
    icon: "HiOutlineFlag",
    type: NAV_ITEM_TYPE_COLLAPSE,
    authority: [],
    subMenu: [
      {
        key: "gerentialDashboard",
        path: "/gerential-dashboard",
        title: "Dashboard Gerencial",
        translateKey: "nav.managementDashboard",
        icon: "HiOutlinePresentationChartLine",
        type: NAV_ITEM_TYPE_ITEM,
        authority: [],
        subMenu: [],
      },
      {
        key: "operationalView",
        path: "/operational-view",
        title: "Visão Operacional",
        translateKey: "nav.operationalView",
        icon: "HiOutlineTrendingUp",
        type: NAV_ITEM_TYPE_ITEM,
        authority: [],
        subMenu: [],
      },
      {
        key: "managementReports",
        path: "/management-reports",
        title: "Relatórios Gerenciais",
        translateKey: "nav.managementReports",
        icon: "HiOutlineTrendingUp",
        type: NAV_ITEM_TYPE_ITEM,
        authority: ["email:marques", "email:jabil", "email:cometrix", "email:qatrix", "email:provital", "email:galena", "email:netafim", "email:symrise"],
        subMenu: [],
      },
      {
        key: "controlTower",
        path: "/control-tower",
        title: "Gestão de FreeTime",
        translateKey: "",
        icon: "HiOutlineClock",
        type: NAV_ITEM_TYPE_ITEM,
        authority: [
          "user",
          "user_cometrix_vsantos",
          "user_supply_chain_manager",
          "user_importation_analyst",
        ],
        subMenu: [],
      },
      {
        key: "performanceRoute",
        path: "/performance-route",
        title: "Atraso e Desvios",
        translateKey: "nav.delayAndDeviations",
        icon: "HiOutlineClock",
        type: NAV_ITEM_TYPE_ITEM,
        authority: [
          "user",
          "user_cometrix_vsantos",
          "user_supply_chain_manager",
          "user_importation_analyst",
        ],
        subMenu: [],
      },
      {
        key: "routeControl",
        path: "/route-control",
        title: "Controle de Rotas",
        translateKey: "nav.routeControl",
        icon: "HiOutlineFlag",
        type: NAV_ITEM_TYPE_ITEM,
        authority: [],
        subMenu: [],
      },
      {
        key: "transportControl",
        path: "/transport-control",
        title: "Controle de Transporte",
        translateKey: "nav.transportControl",
        icon: "HiOutlineFlag",
        type: NAV_ITEM_TYPE_ITEM,
        authority: [],
        subMenu: [],
      },
    ],
  },
  {
    key: "AiDocument",
    path: "/ai-documents",
    title: "TOM",
    translateKey: "",
    icon: <TomSvg />,
    type: NAV_ITEM_TYPE_ITEM,
    authority: ["user", "user_pharmedical", "user_cometrix_vsantos"],
    subMenu: [],
  },
  {
    key: "myOrders",
    path: "",
    title: "Gestão de Pedidos",
    translateKey: "nav.orderManagement",
    icon: "HiOutlineClipboardList",
    type: NAV_ITEM_TYPE_COLLAPSE,
    authority: [
      "user",
      "user_pharmedical",
      "user_cometrix_vsantos",
      "user_supply_chain_manager",
      "user_importation_analyst",
    ],
    subMenu: [
      {
        key: "myImportOrders",
        path: "/order-management?op=I",
        title: "Importação",
        translateKey: "nav.importOrders",
        icon: "HiOutlineDownload",
        type: NAV_ITEM_TYPE_ITEM,
        authority: [
          "user",
          "user_pharmedical",
          "user_cometrix_vsantos",
          "user_supply_chain_manager",
          "user_importation_analyst",
        ],
        subMenu: [],
      },
      {
        key: "myExportOrders",
        path: "/order-management?op=E",
        title: "Exportação",
        translateKey: "nav.exportOrders",
        icon: "HiOutlineUpload",
        type: NAV_ITEM_TYPE_ITEM,
        authority: [],
        subMenu: [],
      },
    ],
  },
  {
    key: "shipments",
    path: "",
    title: "Jornada do Embarque",
    translateKey: "nav.shipmentJourney",
    icon: "HiOutlineTemplate",
    type: NAV_ITEM_TYPE_COLLAPSE,
    authority: [
      "user",
      "user_pharmedical",
      "user_cometrix_vsantos",
      "operator",
      "agent",
    ],
    subMenu: [
      {
        key: "journeyImport",
        path: "/journey?operationValue=I",
        title: "Importação",
        translateKey: "nav.importJourney",
        icon: "HiGlobeAlt",
        type: NAV_ITEM_TYPE_ITEM,
        authority: [],
        subMenu: [],
      },
      {
        key: "journeyExport",
        path: "/journey?operationValue=E",
        title: "Exportação",
        translateKey: "nav.exportJourney",
        icon: "HiGlobeAlt",
        type: NAV_ITEM_TYPE_ITEM,
        authority: [],
        subMenu: [],
      },
    ],
  },
  {
    key: "myPayments",
    path: "/payment-management",
    title: "Gestão de Pagamentos",
    translateKey: "nav.paymentManagement",
    icon: "HiOutlineClipboardCheck",
    type: NAV_ITEM_TYPE_ITEM,
    authority: [
      "email:union",
      "email:skintech",
      "email:provital",
      "email:marques",
      "email:cliente.cometrix",
      "email:qatrix@teste.com.br",
      "email:cmx.qa@cometrix.com.br",
      "email:netafim",
      "email:galena",
      "email:mayekawa",
      "email:gowanco",
      "email:Gowan@cometrix.com.br",
      "email:Irizar@cometrix.com.br"
    ],
    subMenu: [],
  },
  {
    key: "quotationsGroup",
    path: "",
    title: "Cotações",
    translateKey: "nav.quotations",
    icon: "HiOutlinePencilAlt",
    type: NAV_ITEM_TYPE_COLLAPSE,
    authority: [
      "user",
      "user_pharmedical",
      "user_cometrix_vsantos",
      "operator",
      "user_supply_chain_manager",
    ],
    subMenu: [
      {
        key: "newQuotation",
        path: "/new-quotation",
        title: "Nova Cotação",
        translateKey: "nav.newQuotation",
        icon: "HiOutlineFolderAdd",
        type: NAV_ITEM_TYPE_ITEM,
        authority: [
          "user",
          "user_cometrix_vsantos",
          "user_supply_chain_manager",
          "user_importation_analyst",
        ],
        subMenu: [],
      },
      {
        key: "myQuotations",
        path: "/my-quotations",
        title: "Minhas Cotações",
        translateKey: "nav.myQuotations",
        icon: "HiOutlineCalculator",
        type: NAV_ITEM_TYPE_ITEM,
        authority: [
          "user",
          "operator",
          "user_cometrix_vsantos",
          "user_supply_chain_manager",
        ],
        subMenu: [],
      },
    ],
  },
  {
    key: "shipmentActivityBoard",
    path: "/shipment-activity-board",
    title: "Minhas Atividades",
    translateKey: "nav.myActivities",
    icon: "HiOutlineBookOpen",
    type: NAV_ITEM_TYPE_ITEM,
    authority: [],
    subMenu: [],
  },
  {
    key: "VSantosReports",
    path: "/reports",
    title: "Relatórios",
    translateKey: "",
    icon: "HiOutlineTemplate",
    type: NAV_ITEM_TYPE_COLLAPSE,
    authority: ["vsantos_customer", "vsantos_admin"],
    subMenu: [
      {
        key: "reportCustoProcesso",
        path: "/custo-processo",
        title: "Custo por Processo",
        translateKey: "",
        icon: "",
        type: NAV_ITEM_TYPE_ITEM,
        authority: ["vsantos_customer", "vsantos_admin"],
        subMenu: [],
      },
      {
        key: "reportCustoItem",
        path: "/custo-item",
        title: "Custo por Item",
        translateKey: "",
        icon: "",
        type: NAV_ITEM_TYPE_ITEM,
        authority: ["vsantos_customer", "vsantos_admin"],
        subMenu: [],
      },
    ],
  },
  {
    key: "VSantosProcessos",
    path: "/processos",
    title: "Processos",
    translateKey: "",
    icon: "HiOutlineTemplate",
    type: NAV_ITEM_TYPE_ITEM,
    authority: ["vsantos_customer", "vsantos_admin"],
    subMenu: [],
  },
  {
    key: "VSantosGridProcessos",
    path: "/grid-processos",
    title: "Grid Processos",
    translateKey: "",
    icon: "HiOutlineTemplate",
    type: NAV_ITEM_TYPE_ITEM,
    authority: ["vsantos_customer", "vsantos_admin"],
    subMenu: [],
  },
  {
    key: "VSantosKPIs",
    path: "/kpis",
    title: "KPIs",
    translateKey: "",
    icon: "HiOutlineTemplate",
    type: NAV_ITEM_TYPE_COLLAPSE,
    authority: ["vsantos_customer", "vsantos_admin"],
    subMenu: [
      {
        key: "kpiAereo",
        path: "/kpi-aereo",
        title: "KPI Performance Aéreo",
        translateKey: "",
        icon: "",
        type: NAV_ITEM_TYPE_ITEM,
        authority: ["vsantos_customer", "vsantos_admin"],
        subMenu: [],
      },
      {
        key: "kpiMaritimo",
        path: "/kpi-maritimo",
        title: "KPI Performance Marítimo",
        translateKey: "",
        icon: "",
        type: NAV_ITEM_TYPE_ITEM,
        authority: ["vsantos_customer", "vsantos_admin"],
        subMenu: [],
      },
      {
        key: "kpiRodoviario",
        path: "/kpi-rodoviario",
        title: "KPI Performance Rodoviário",
        translateKey: "",
        icon: "",
        type: NAV_ITEM_TYPE_ITEM,
        authority: ["vsantos_customer", "vsantos_admin"],
        subMenu: [],
      },
    ],
  },
  {
    key: "quotations",
    path: "/quotations",
    title: "Cotações",
    translateKey: "nav.quotations",
    icon: "HiOutlineCalculator",
    type: NAV_ITEM_TYPE_ITEM,
    authority: ["admin"],
    subMenu: [],
  },
  {
    key: "shipments",
    path: "/shipments",
    title: "Embarques",
    translateKey: "nav.shipments",
    icon: "HiOutlineTemplate",
    type: NAV_ITEM_TYPE_ITEM,
    authority: ["admin"],
    subMenu: [],
  },
  // {
  //   key: "myNotificationsUser",
  //   path: "/my-notifications",
  //   title: "Minhas Notificações",
  //   translateKey: "",
  //   icon: "HiOutlineBell",
  //   type: NAV_ITEM_TYPE_ITEM,
  //   authority: [
  //     "user",
  //     "user_pharmedical",
  //     "agent",
  //     "operator",
  //     "user_cometrix_vsantos",
  //     "user_supply_chain_manager",
  //     "user_financial_analyst",
  //     "user_financial_manager",
  //     "user_importation_analyst",
  //   ],
  //   subMenu: [],
  // },
  {
    key: "customers",
    path: "/customers",
    title: "Single menu item",
    translateKey: "nav.customers",
    icon: "HiOutlineUserGroup",
    type: NAV_ITEM_TYPE_ITEM,
    authority: ["admin"],
    subMenu: [],
  },
  {
    key: "users",
    path: "/users",
    title: "Single menu item",
    translateKey: "nav.users",
    icon: "HiOutlineUserGroup",
    type: NAV_ITEM_TYPE_ITEM,
    authority: ["admin"],
    subMenu: [],
  },

  {
    key: "reports.myReports",
    path: "/reports/my-reports",
    title: "Painel de Relatórios",
    translateKey: "nav.reports",
    icon: "HiOutlineChartSquareBar",
    type: NAV_ITEM_TYPE_ITEM,
    authority: [
      "admin",
      "user",
      "user_pharmedical",
      "user_cometrix_vsantos",
      "user_supply_chain_manager",
      "user_financial_analyst",
      "user_financial_manager",
    ],
    subMenu: [],
  },
  {
    key: "pharmedical",
    path: "/myCustomizations",
    title: "Meus Cadastros",
    translateKey: "nav.config",
    icon: "HiOutlineUserGroup",
    type: NAV_ITEM_TYPE_COLLAPSE,
    authority: ["user_pharmedical"],
    subMenu: [
      {
        key: "config.customerManufacturer",
        path: "/config/customer-manufacturer",
        title: "Fabricantes",
        translateKey: "nav.reports.myReports",
        icon: "",
        type: NAV_ITEM_TYPE_ITEM,
        authority: [],
        subMenu: [],
      },
      {
        key: "config.customerProvider",
        path: "/config/customer-provider",
        title: "Fornecedores",
        translateKey: "nav.reports.myReports",
        icon: "",
        type: NAV_ITEM_TYPE_ITEM,
        authority: [],
        subMenu: [],
      },
      {
        key: "config.customerProduct",
        path: "/config/customer-product",
        title: "Medicamentos",
        translateKey: "nav.reports.myReports",
        icon: "",
        type: NAV_ITEM_TYPE_ITEM,
        authority: [],
        subMenu: [],
      },
      {
        key: "config.customerProposal",
        path: "/config/customer-proposal",
        title: "Orçamentos",
        translateKey: "",
        icon: "",
        type: NAV_ITEM_TYPE_ITEM,
        authority: [],
        subMenu: [],
      },
    ],
  },
  {
    key: "VSantosTracking",
    path: "",
    title: "Tracking V.Santos",
    translateKey: "",
    icon: "HiOutlineTruck",
    type: NAV_ITEM_TYPE_COLLAPSE,
    authority: ["user_cometrix_vsantos"],
    subMenu: [
      {
        key: "VSantosProcessos",
        path: "/processos",
        title: "Processos",
        translateKey: "",
        icon: "HiOutlineTemplate",
        type: NAV_ITEM_TYPE_ITEM,
        authority: [],
        subMenu: [],
      },
      {
        key: "kpiAereo",
        path: "/kpi-aereo",
        title: "KPI Performance - Aéreo",
        translateKey: "",
        icon: "",
        type: NAV_ITEM_TYPE_ITEM,
        authority: [],
        subMenu: [],
      },
      {
        key: "kpiMaritimo",
        path: "/kpi-maritimo",
        title: "KPI Performance - Marítimo",
        translateKey: "",
        icon: "",
        type: NAV_ITEM_TYPE_ITEM,
        authority: [],
        subMenu: [],
      },
      {
        key: "kpiRodoviario",
        path: "/kpi-rodoviario",
        title: "KPI Performance - Rodoviário",
        translateKey: "",
        icon: "",
        type: NAV_ITEM_TYPE_ITEM,
        authority: [],
        subMenu: [],
      },
      {
        key: "reportCustoProcesso",
        path: "/custo-processo",
        title: "Relatório - Custo por Processo",
        translateKey: "",
        icon: "",
        type: NAV_ITEM_TYPE_ITEM,
        authority: [],
        subMenu: [],
      },
      {
        key: "reportCustoItem",
        path: "/custo-item",
        title: "Relatório - Custo por Item",
        translateKey: "",
        icon: "",
        type: NAV_ITEM_TYPE_ITEM,
        authority: [],
        subMenu: [],
      },
    ],
  },
  {
    key: "otherConfigs",
    path: "/configurations",
    title: "Mais Configurações",
    translateKey: "nav.moreConfigs",
    icon: "HiOutlineCog",
    type: NAV_ITEM_TYPE_ITEM,
    authority: [
      "user",
      "user_pharmedical",
      "user_cometrix_vsantos",
      "user_basic"
    ],
    isGroupedConfig: true,
    subMenu: [],
    items: [
      {
        key: "myWarehouses",
        path: "/warehouse",
        title: "Cadastro de Armazéns",
        description: "Gerencie aqui a sua lista de Armazéns.",
        translateKey: "",
        icon: "HiOutlineHome",
        type: NAV_ITEM_TYPE_ITEM,
        authority: [],
        subMenu: [],
      },
      {
        key: "myPartners",
        path: "/agents",
        title: "Despachantes",
        description: "Gerencie aqui a sua lista de Despachantes.",
        translateKey: "",
        icon: "HiOutlineUsers",
        type: NAV_ITEM_TYPE_ITEM,
        authority: [],
        subMenu: [],
      },
      {
        key: "config.customerProduct",
        path: "/config/customer-product",
        title: "Produtos",
        description: "Aqui você pode gerenciar a sua lista de Produtos.",
        translateKey: "nav.reports.myReports",
        icon: "HiOutlinePuzzle",
        type: NAV_ITEM_TYPE_ITEM,
        authority: ["user", "user_cometrix_vsantos"],
        subMenu: [],
      },
      {
        key: "config.customerManufacturer",
        path: "/config/customer-manufacturer",
        title: "Fabricantes",
        description: "Gerencie aqui a sua lista de Fabricantes.",
        translateKey: "nav.reports.myReports",
        icon: "HiOutlineBeaker",
        type: NAV_ITEM_TYPE_ITEM,
        authority: ["user", "admin", "user_cometrix_vsantos"],
        subMenu: [],
      },
      {
        key: "myOperators",
        path: "/operators",
        title: "Agentes de Carga",
        description: "Gerencie aqui a sua lista de Agentes de Carga.",
        translateKey: "",
        icon: "HiOutlineTruck",
        type: NAV_ITEM_TYPE_ITEM,
        authority: ["user", "admin", "user_cometrix_vsantos"],
        subMenu: [],
      },
      {
        key: "freeTime",
        path: "/freeTime",
        title: "Free Time",
        description: "Gerencie aqui o seu Free Time.",
        translateKey: "",
        icon: "HiOutlineClock",
        type: NAV_ITEM_TYPE_ITEM,
        authority: [
          "user",
          "admin",
          "user_pharmedical",
          "user_cometrix_vsantos",
          "vsantos_admin",
          "user_supply_chain_manager",
          "user_importation_analyst",
        ],
        subMenu: [],
      },
      {
        key: "operationalSLA",
        path: "/operational-sla",
        title: "SLA Operacional",
        description: "Gerencie aqui o seu SLA Operacional.",
        translateKey: "",
        icon: "HiOutlineCalendar",
        type: NAV_ITEM_TYPE_ITEM,
        authority: [],
        subMenu: [],
      },
      {
        key: "mySuppliers",
        path: "/suppliers",
        title: "Fornecedores",
        description: "Gerencie aqui a sua lista de Fornecedores.",
        translateKey: "",
        icon: "HiOutlineBriefcase",
        type: NAV_ITEM_TYPE_ITEM,
        authority: ["user", "admin", "user_cometrix_vsantos"],
        subMenu: [],
      },
      {
        key: "config.customerCustomer",
        path: "/config/customer-customer",
        title: "Cadastro de Clientes",
        description: "Gerencie aqui a sua lista de Clientes.",
        translateKey: "nav.reports.myReports",
        icon: "HiOutlineUserGroup",
        type: NAV_ITEM_TYPE_ITEM,
        authority: [],
        subMenu: [],
      },
      {
        key: "config.customerCarriers",
        path: "/config/customerCarriers",
        title: "Transportadores",
        description: "Gerencie aqui a sua lista de Transportadores.",
        translateKey: "",
        icon: "HiGlobeAlt",
        type: NAV_ITEM_TYPE_ITEM,
        authority: ["user", "admin", "user_pharmedical"],
        subMenu: [],
      },
      {
        key: "config.trix",
        path: "/config/trix",
        title: "IA - Trix",
        description:
          "Configurações da Trix, agente de IA de leitura e automatação de e-mails",
        translateKey: "",
        icon: <TrixSvg />,
        type: NAV_ITEM_TYPE_ITEM,
        authority: [
          "user",
          "admin",
          "user_pharmedical",
          "email:sebastiao.junior@mayekawa.com.br",
          "email:lucimari.modesto@mayekawa.com.br",
          "email:fabio.oliveira@mayekawa.com.br",
          "email:rodrigo.luiz@mayekawa.com.br",
          "email:marco.colella@mayekawa.com.br",
          "email:paulo.correa@mayekawa.com.br",
          "email:@irizar.com.br",
          "email:@cometrix.com.br"
        ],
        subMenu: [],
      },
      {
        key: "config.notification",
        path: "/config/customerNotificationShipmentStep",
        title: "Notificações",
        description: "Configurações de Notificação",
        translateKey: "",
        icon: <HiOutlineInformationCircle />,
        type: NAV_ITEM_TYPE_ITEM,
        authority: ["user", "admin", "user_pharmedical"],
        subMenu: [],
      },
      {
        key: "aiConfiguration",
        path: "/ai-configuration",
        title: "IA - Tom",
        description:
          "Configurações do TOM, agente de IA para leitura de documentos.",
        translateKey: "",
        icon: <TomSvg />,
        type: NAV_ITEM_TYPE_ITEM,
        authority: [],
        subMenu: [],
      },
      {
        key: "aiConfiguration",
        path: "/ai-configuration",
        title: "IA - Oráculo",
        description: "Configurações do Oráculo, agente de IA conversacional.",
        translateKey: "",
        icon: <OraculoSvg />,
        type: NAV_ITEM_TYPE_ITEM,
        authority: [],
        subMenu: [],
      },
      {
        key: "journeyConfig",
        path: "/config/journey",
        title: "Jornada",
        description: "Gerencie aqui a sua jornada de embarque.",
        translateKey: "",
        icon: "HiOutlineArrowsExpand",
        type: NAV_ITEM_TYPE_ITEM,
        authority: [],
        subMenu: [],
      },
      {
        key: "config.customerParameter",
        path: "/config/customer-parameter",
        title: "Cadastro de Parâmetros",
        description: "Gerencie aqui os parâmetros do sistema.",
        translateKey: "nav.reports.myReports",
        icon: "",
        type: NAV_ITEM_TYPE_ITEM,
        authority: ["admin"],
        subMenu: [],
      },
      {
        key: "config.customerTerminal",
        path: "/config/customer-terminal",
        title: "Cadastro de Terminais",
        description: "Gerencie aqui os terminais do sistema.",
        translateKey: "nav.reports.myReports",
        icon: <HiOutlineViewBoards />,
        type: NAV_ITEM_TYPE_ITEM,
        authority: [],
        subMenu: [],
      },
    ],
  },
  {
    key: "myPendingsAdmin",
    path: "/my-pendings",
    title: "Pendências",
    translateKey: "",
    icon: "HiOutlineExclamation",
    type: NAV_ITEM_TYPE_ITEM,
    authority: ["admin"],
    subMenu: [],
  },
  {
    key: "myNotificationsAdmin",
    path: "/my-notifications",
    title: "Notificações",
    translateKey: "",
    icon: "HiOutlineBell",
    type: NAV_ITEM_TYPE_ITEM,
    authority: ["admin"],
    subMenu: [],
  },

  {
    key: "config",
    path: "/configurations",
    title: "Configurações",
    translateKey: "nav.config",
    icon: "HiOutlineChartSquareBar",
    type: NAV_ITEM_TYPE_COLLAPSE,
    authority: ["admin"],
    subMenu: [
      {
        key: "config.containterType",
        path: "/config/container-types",
        title: "Tipos de Container",
        translateKey: "nav.reports.myReports",
        icon: "",
        type: NAV_ITEM_TYPE_ITEM,
        authority: ["admin"],
        subMenu: [],
      },
      {
        key: "config.country",
        path: "/config/countries",
        title: "Países",
        translateKey: "nav.reports.myReports",
        icon: "",
        type: NAV_ITEM_TYPE_ITEM,
        authority: ["admin"],
        subMenu: [],
      },
      {
        key: "config.reports",
        path: "/config/reports",
        title: "Relatórios",
        translateKey: "nav.reports.myReports",
        icon: "",
        type: NAV_ITEM_TYPE_ITEM,
        authority: ["admin"],
        subMenu: [],
      },
      {
        key: "config.carriers",
        path: "/config/carriers",
        title: "Transportadores",
        translateKey: "nav.reports.myReports",
        icon: "",
        type: NAV_ITEM_TYPE_ITEM,
        authority: ["admin"],
        subMenu: [],
      },
      {
        key: "config.expenseType",
        path: "/config/expenses",
        title: "Tipos de Despesa",
        translateKey: "nav.reports.myReports",
        icon: "",
        type: NAV_ITEM_TYPE_ITEM,
        authority: ["admin"],
        subMenu: [],
      },
      {
        key: "config.marketNews",
        path: "/config/market-news",
        title: "Notícias do Mercado",
        translateKey: "nav.reports.myReports",
        icon: "",
        type: NAV_ITEM_TYPE_ITEM,
        authority: ["admin"],
        subMenu: [],
      },
      {
        key: "config.incoterms",
        path: "/config/incoterms",
        title: "Incoterms",
        translateKey: "nav.reports.myReports",
        icon: "",
        type: NAV_ITEM_TYPE_ITEM,
        authority: ["admin"],
        subMenu: [],
      },
      {
        key: "config.currency",
        path: "/config/currencies",
        title: "Moedas",
        translateKey: "nav.reports.myReports",
        icon: "",
        type: NAV_ITEM_TYPE_ITEM,
        authority: ["admin"],
        subMenu: [],
      },
      {
        key: "config.loadType",
        path: "/config/load-types",
        title: "Tipos de Carga",
        translateKey: "nav.reports.myReports",
        icon: "",
        type: NAV_ITEM_TYPE_ITEM,
        authority: ["admin"],
        subMenu: [],
      },
      {
        key: "config.locationTypes",
        path: "/config/location-types",
        title: "Tipos de Localização",
        translateKey: "nav.reports.myReports",
        icon: "",
        type: NAV_ITEM_TYPE_ITEM,
        authority: ["admin"],
        subMenu: [],
      },
      {
        key: "config.locations",
        path: "/config/locations",
        title: "Localizações",
        translateKey: "nav.reports.myReports",
        icon: "",
        type: NAV_ITEM_TYPE_ITEM,
        authority: ["admin"],
        subMenu: [],
      },
      {
        key: "config.modals",
        path: "/config/modals",
        title: "Modais",
        translateKey: "nav.reports.myReports",
        icon: "",
        type: NAV_ITEM_TYPE_ITEM,
        authority: ["admin"],
        subMenu: [],
      },
      {
        key: "config.packageTypes",
        path: "/config/package-types",
        title: "Tipos de Embalagem",
        translateKey: "nav.reports.myReports",
        icon: "",
        type: NAV_ITEM_TYPE_ITEM,
        authority: ["admin"],
        subMenu: [],
      },
      {
        key: "config.documentTypes",
        path: "/config/document-types",
        title: "Tipos de Documento",
        translateKey: "nav.reports.myReports",
        icon: "",
        type: NAV_ITEM_TYPE_ITEM,
        authority: ["admin"],
        subMenu: [],
      },
      {
        key: "config.customerManufacturer",
        path: "/config/customer-manufacturer",
        title: "Fabricantes",
        translateKey: "nav.reports.myReports",
        icon: "",
        type: NAV_ITEM_TYPE_ITEM,
        authority: ["admin"],
        subMenu: [],
      },
      {
        key: "config.customerProvider",
        path: "/config/customer-provider",
        title: "Cadastro de Fornecedores",
        translateKey: "nav.reports.myReports",
        icon: "",
        type: NAV_ITEM_TYPE_ITEM,
        authority: ["admin"],
        subMenu: [],
      },
      {
        key: "config.customerProduct",
        path: "/config/customer-product",
        title: "Medicamentos",
        translateKey: "nav.reports.myReports",
        icon: "",
        type: NAV_ITEM_TYPE_ITEM,
        authority: ["admin"],
        subMenu: [],
      },
      {
        key: "config.customerCustomer",
        path: "/config/customer-customer",
        title: "Cadastro de Clientes",
        translateKey: "nav.reports.myReports",
        icon: "",
        type: NAV_ITEM_TYPE_ITEM,
        authority: ["admin"],
        subMenu: [],
      },
      {
        key: "config.userProfile",
        path: "/config/user-profile",
        title: "Perfis de usuários",
        translateKey: "nav.reports.myReports",
        icon: "",
        type: NAV_ITEM_TYPE_ITEM,
        authority: ["admin"],
        subMenu: [],
      },
      {
        key: "config.notificationTypes",
        path: "/config/notification-types",
        title: "Tipos de Notificação",
        translateKey: "nav.reports.myReports",
        icon: "",
        type: NAV_ITEM_TYPE_ITEM,
        authority: ["admin"],
        subMenu: [],
      },
      {
        key: "config.useDashboard",
        path: "/config/use-dashboard",
        title: "Dashboard de Uso",
        translateKey: "nav.reports.myReports",
        icon: "",
        type: NAV_ITEM_TYPE_ITEM,
        authority: ["admin"],
        subMenu: [],
      },
      {
        key: "myIntegrators",
        path: "/integrators",
        title: "Integrações",
        translateKey: "",
        icon: "",
        type: NAV_ITEM_TYPE_ITEM,
        authority: [],
        subMenu: [],
      },
      {
        key: "trackingControlTower",
        path: "/tracking-control-tower",
        title: "Torre de Controle - Tracking",
        translateKey: "",
        icon: "",
        type: NAV_ITEM_TYPE_ITEM,
        authority: [],
        subMenu: [],
      },
      {
        key: "duimpControlTower",
        path: "/duimp-control-tower",
        title: "Torre de Controle - Integrações",
        translateKey: "",
        icon: "",
        type: NAV_ITEM_TYPE_ITEM,
        authority: [],
        subMenu: [],
      },
      {
        key: "integrationControlDash",
        path: "/monitoramento-integracoes",
        title: "Monitoramento - Integrações",
        translateKey: "",
        icon: "",
        type: NAV_ITEM_TYPE_ITEM,
        authority: [],
        subMenu: [],
      },
      {
        key: "config.siscomex.certificados",
        path: "/config/siscomex/certificados",
        title: "Certificados Digitais (Siscomex)",
        translateKey: "",
        icon: "HiOutlineShieldCheck",
        type: NAV_ITEM_TYPE_ITEM,
        authority: ["admin"],
        subMenu: [],
      },
    ],
  },
];

export default navigationConfig;
